// components/ui/PaginationComponent.jsx
import React from "react";
import ReactPaginate from "react-paginate";
import './Pagination.css'; // optional: if you want custom styles

const PaginationComponent = ({ pageCount, onPageChange, forcePage = 0 }) => {
  return (
    <ReactPaginate
      pageCount={pageCount}
      pageRangeDisplayed={3}
      marginPagesDisplayed={2}
      forcePage={forcePage}
      onPageChange={onPageChange}
      containerClassName="pagination"
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      breakClassName="page-item"
      breakLinkClassName="page-link"
      activeClassName="active"
    />
  );
};

export default PaginationComponent;
